export default {
  CHANGE: 'CHANGE'
};

export function CategoryOptions() {
  return [ '', 'General', 'UI Automation', 'API Automation', 'Unit Testing', 'DevOps', 'Development', 'Databases'];
};

export function Languages() {
  return ['', 'Java', 'CSharp', 'Python', 'Ruby', 'JavaScript', 'TypeScript', 'Cpp', 'Swift'];
};